// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2Y0H-","list":"PatternAutocomplete_list__2E9vE"};